<script lang="ts">
  import { defineComponent, ref, computed } from 'vue';
  import {
    createAppProviderContext,
    APP_CONTEXXT,
    defaultConfig,
  } from '@/hooks/useAppContext';
  import { queryStoreHouseList } from '@/api/goods';
  import { cloneDeep } from 'lodash';
  import { useUserStore } from '@/store';

  export default defineComponent({
    name: 'AppProvider',
    inheritAttrs: false,
    setup(_, { slots }) {
      const userStore = useUserStore();
      const userId = computed(() => {
        return userStore.userLoginInfo.id;
      });
      const conf = ref(cloneDeep(defaultConfig));
      function setDefaultConfig(params: Recordable) {
        conf.value = { ...conf.value, ...params };
        if (conf.value) {
          window.localStorage.setItem(
            APP_CONTEXXT.toString(),
            JSON.stringify(conf.value)
          );
        }
      }
      const config = window.localStorage.getItem(APP_CONTEXXT.toString());
      if (config && JSON.parse(config)) {
        setDefaultConfig(JSON.parse(config));
      }
      async function getDefaultStorehouse(curContext: Recordable) {
        try {
          const { storehouse } = defaultConfig;
          const data: Recordable = { state: 1 };
          if (storehouse?.storehouseId) {
            data.id = storehouse.storehouseId;
          }
          const res = await queryStoreHouseList(data, { page: 1, limit: 1 });
          if (res.data) {
            const { list } = res.data;
            if (list.length === 1) {
              curContext.setDefaultConfig({
                storehouse: {
                  storehouseId: list[0].id,
                  storehouseName: list[0].name,
                },
              });
            }
          }
          return Promise.resolve(storehouse);
        } catch (error) {
          return Promise.reject(error);
        }
      }
      const getDefaultMulStaff = (curContext: Recordable) => {
        if (
          Array.isArray(curContext.defaultConfig.mulSelectStaff) &&
          curContext.defaultConfig.mulSelectStaff.length
        ) {
          return Promise.resolve(curContext.defaultConfig.mulSelectStaff);
        }
        curContext.setDefaultConfig({
          mulSelectStaff: [userId.value],
        });
        return Promise.resolve([userId.value]);
      };
      createAppProviderContext<any>({
        defaultConfig: conf,
        setDefaultConfig,
        getDefaultStorehouse,
        getDefaultMulStaff,
      } as any);
      return () => slots.default?.();
    },
  });
</script>
